var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 17,
    viewBox: "0 0 138 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.891,
    width: 137.467,
    height: 16.029,
    rx: 8,
    fill: "var(--color-grey34)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.064 8.553a.5.5 0 0 0 0 .707l3.182 3.182a.5.5 0 1 0 .707-.707L8.124 8.906l2.829-2.828a.5.5 0 1 0-.707-.707L7.064 8.553zm122.985-.147H7.417v1H130.05v-1z",
    fill: "var(--color-white)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.bda4e1fc199c0088f9db552da0b43905.svg";
export { ForwardRef as ReactComponent };